import axios from "axios";
import { HOST_URL } from "./Host";

export const SET_USER_COMPANIES = "SET_USER_COMPANIES";
export const SET_ACTIVE_COMPANY = "SET_ACTIVE_COMPANY";
export const SET_COMPANY = "SET_COMPANY";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Accept-Version": "2.0",
};

export function setUserCompanies(companies) {
  return {
    type: SET_USER_COMPANIES,
    payload: companies,
  };
}

export function setActiveCompany(company) {
  return {
    type: SET_ACTIVE_COMPANY,
    payload: company,
  };
}

export function setCompany(company) {
  return {
    type: SET_COMPANY,
    payload: company,
  };
}

export function getUserCompanies(token, page = 1, limit = 10) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${HOST_URL}/companies?page=${page}&limit=${limit}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(
        setUserCompanies({
          data: response.data.data,
          meta: response.data.meta,
        })
      );
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);
    }
  };
}

// Every company visible to staff, loaded by pages of 100 (API maximum)
export function getAllCompanies(token) {
  return async (dispatch) => {
    const limit = 100;
    const companies = [];
    let total = Infinity;

    try {
      for (let page = 1; companies.length < total && page <= 50; page += 1) {
        const response = await axios.get(
          `${HOST_URL}/companies?page=${page}&limit=${limit}`,
          {
            headers: {
              ...headers,
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = response.data.data || [];

        companies.push(...data);
        total = response.data.meta?.total ?? companies.length;
        if (data.length < limit) break;
      }

      await dispatch(
        setUserCompanies({
          data: companies,
          meta: { total: companies.length, page: 1, limit: companies.length },
        })
      );
    } catch (error) {
      console.log(error.response?.data?.message || error.message);
    }
  };
}

export function createCompany(token, companyData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${HOST_URL}/companies`, companyData, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });
      await dispatch(setCompany(response.data.data));
      await dispatch(getUserCompanies(token));
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }
      console.log(errorMessage);

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function getCompanyByRequest(token, request, callback) {
  return async () => {
    try {
      const response = await axios.get(
        `${HOST_URL}/companies?request=${request}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      callback({
        success: true,
        message: response.data.message,
        data: response.data.data[0],
      });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function getOdooAccount(token, company, callback) {
  return async () => {
    try {
      const response = await axios.get(`${HOST_URL}/odoo/${company}`, {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });
      console.log();

      callback(response.data.data);
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function updateOdooAccount(token, company, odooData, callback) {
  return async () => {
    try {
      const response = await axios.put(
        `${HOST_URL}/odoo/${company}`,
        odooData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      callback({ success: true, message: response.data.message });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}
